/**
 * Formatea una fecha en formato de 24 horas (hh:mm), asegurando dos dígitos.
 * 
 * @param {string|number|Date} time - Fecha o timestamp válido.
 * @returns {string} Hora formateada en formato "HH:MM".
 */
export const hourFormat = time => {
  const date = new Date(time);
  if (isNaN(date.getTime())) {
    return '--:--';
  }
  return new Intl.DateTimeFormat('es-ES', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  }).format(date);
}

/**
 * Formatea una fecha al estilo español: `DD Mes, YYYY`.
 * Ejemplo: `5 Julio, 2024`.
 * 
 * @param {string|number|Date} time - Fecha o timestamp válido.
 * @returns {string} Fecha formateada.
 */
export const dateFormatDDmesAnio = time => {
  const date = new Date(time);
  if (isNaN(date.getTime())) {
    return 'Fecha inválida';
  }
  const formatter = new Intl.DateTimeFormat('es-ES', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
  
  const parts = formatter.formatToParts(date);
  const day = parts.find(p => p.type === 'day').value;
  const month = parts.find(p => p.type === 'month').value
    .replace(/^\w/, c => c.toUpperCase());
  const year = parts.find(p => p.type === 'year').value;

  return `${day} ${month}, ${year}`;
}

/**
 * Genera un identificador de sesión aleatorio.
 * Ejemplo de salida: _5gkf93jkd
 * 
 * @returns {string} ID de sesión pseudoaleatorio.
 */
export const generateSessionId = () => {
  return `_${Math.random().toString(36).substring(2, 11)}`;
}